module.exports = __webpack_public_path__ + "media/images/emblems/Kriechenwil-coat_of_arms-1295b790f46f59ddc29df1002d692f8e.svg";